<template>
  <div class="h-tab-wrap" :class="$i18n.locale">
    <div :class="['iconfont', icon]"></div>
    <div class="content">
      <span class="label">{{ label }}:</span>
      <span class="value">{{ value }}</span>
      <span v-if="unit" class="unit">{{ unit }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String],
      default: ''
    }
  }
};
</script>

<style lang="scss">
.light {
  .h-tab-wrap {
    color: var(--text-color1);
  }
}

.h-tab-wrap {
  font-size: 12px;
  width: 145px;
  height: 31px;
  line-height: 31px;
  background: url('~@/assets/image/customs/x1.png');

  background-size: 100% 100%;
  background-repeat: no-repeat;

  display: flex;
  align-items: center;

  color: #ffffff;

  .iconfont {
    margin: 0 8px 0 12px;
    font-size: 20px;
  }

  &.en {
    width: 250px;
  }

  &.ar {
    width: 186px;
  }

  &.es {
    width: 280px;
  }

  &.fr {
    width: 260px;
  }

  &.ru {
    width: 284px;
  }

  .content {
    .label {
      margin-right: 4px;
    }

    .unit {
      margin-left: 2px;
    }
  }
}
</style>
